export default __webpack_public_path__ + "formThanksImage.0af586e6106927b27fe1af29f9b59555.png";